/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-wrap[_ngcontent-%COMP%]{width:30px;height:100%;display:flex;flex-direction:column;justify-content:space-between;align-items:center;overflow:hidden}.group-1[_ngcontent-%COMP%]{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:5px}i[_ngcontent-%COMP%], mat-icon[_ngcontent-%COMP%]:not(.icon-off){color:var(--icon-color)}.map-legends[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:19px;width:19px}\n/*# sourceMappingURL=feat-map-controls.component.css.map*/"];
export { styles as styles };
